import { contentAdminAxios, requireData, requireSuccess } from '../../common/api/client'
import type { ContentReading, ReadingQuestion } from '../types'

export interface ListReadingsParams {
  page?: number
  size?: number
  q?: string
  cefr?: string
  topic?: string
  taxonomy_term_id?: string
}

export interface ListReadingsResponse {
  items: ContentReading[]
  pagination: { page: number; size: number; total: number }
}

export interface CreateReadingPayload {
  id?: string
  title_sentence_id: string
  summary?: string | null
  image?: string | null
  difficulty?: number | null
  sentences?: Array<{ sentence_id: string; paragraph?: number }> | string[]
  questions?: Array<{
    id?: string
    skill: string
    question: string
    options: string[]
    correct_option: number
    evidence?: string | null
    rationale?: string | null
    position?: number
  }>
}

export interface UpdateReadingPayload {
  title_sentence_id?: string
  summary?: string | null
  image?: string | null
  difficulty?: number | null
}

export const readingsApi = {
  async listReadings(params: ListReadingsParams = {}): Promise<ListReadingsResponse> {
    const res = await contentAdminAxios.get('/readings', { params })
    const items = requireData<ContentReading[]>(res.data, 'Không thể tải danh sách bài đọc')
    return { items, pagination: res.data.pagination ?? { page: params.page || 1, size: params.size || 20, total: items.length } }
  },

  async getReading(id: string): Promise<ContentReading> {
    const res = await contentAdminAxios.get(`/readings/${id}`)
    return requireData<ContentReading>(res.data, 'Không thể tải chi tiết bài đọc')
  },

  async createReading(payload: CreateReadingPayload): Promise<ContentReading> {
    const res = await contentAdminAxios.post('/readings', payload)
    return requireData<ContentReading>(res.data, 'Không thể tạo bài đọc')
  },

  async updateReading(id: string, payload: UpdateReadingPayload): Promise<ContentReading> {
    const res = await contentAdminAxios.patch(`/readings/${id}`, payload)
    return requireData<ContentReading>(res.data, 'Không thể cập nhật bài đọc')
  },

  async replaceReadingSentences(id: string, sentences: Array<{ sentence_id: string; paragraph?: number }> | string[]): Promise<ContentReading> {
    const res = await contentAdminAxios.put(`/readings/${id}/sentences`, { sentences })
    return requireData<ContentReading>(res.data, 'Không thể cập nhật danh sách câu')
  },

  async replaceReadingQuestions(id: string, questions: Partial<ReadingQuestion>[]): Promise<ContentReading> {
    const res = await contentAdminAxios.put(`/readings/${id}/questions`, { questions })
    return requireData<ContentReading>(res.data, 'Không thể cập nhật danh sách câu hỏi')
  },

  async deleteReading(id: string): Promise<void> {
    const res = await contentAdminAxios.delete(`/readings/${id}`)
    requireSuccess(res.data, 'Không thể xóa bài đọc')
  },
}
